import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-site-header="container"]',
    }

    function init() {
        initHeader()
    }

    function initHeader() {

        $(window).scroll(function (event) {
            var scroll = $(window).scrollTop();
            if(scroll > 0){
                $(nodeSelectors.container).addClass('active')
            } else{
                $(nodeSelectors.container).removeClass('active')
            }
        });

        $( ".bottom-nav .sub-menu" ).each(function( index ) {
            $(this).prepend('<div class="close-icon"><img src="'+siteData.theme_url+'/src/images/icons/fermer.svg"/><div>')
        });

        $('.mobile-menu-opener').on('click', function(e){ 
            $(this).toggleClass('active');
            $('#site-mobile-nav').slideToggle();
        }); 

        $('.close-menu-icon').on('click', function(e){ 
            $('.mobile-menu-opener').toggleClass('active');
            $('#site-mobile-nav').slideUp();
        });

        $(window).on('load', function() {
            $('.hero-section').addClass('active')
        });

        $('#site-mobile-nav .menu-item-has-children').on('click', function(){
            $(this).find('.sub-menu').slideToggle('fast')
        })

        $('.bottom-nav .menu-item-has-children').hover(
            function(e) {
                e.stopPropagation();
                $(this).find('.sub-menu').fadeIn('fast').css('display', 'flex')
            }, function() {
                $(document).on('click', '.close-icon, .sub-menu li', function(e){ 
                    e.stopPropagation();
                    $(this).parent().fadeOut('fast')
                }); 
            }
        );

        
    }

    return Object.freeze({
        init,
    })
}